module.exports = __webpack_public_path__ + "img/kruger-united-logo-icon.3c5dabe7.webp";